import React from 'react';
const links = ['Términos y condiciones', 'Política de privacidad', 'Contacto / WhatsApp'];
export function Footer() {
  return <footer className="w-full bg-forest-800 px-5 py-12 text-white/70" data-id="element-71" data-mp="2071832vrpvxe">
      <div className="mx-auto max-w-5xl" data-id="element-72" data-mp="2f53d7hig6pgr">
        <div className="flex flex-col gap-6 border-b border-white/10 pb-8 md:flex-row md:items-start md:justify-between" data-id="element-73" data-mp="2f41zt6dylqvv">
          <div className="max-w-sm" data-id="element-74" data-mp="1mg5uxee8kso0">
            <p className="font-display text-lg font-semibold text-white" data-id="element-75" data-mp="1mh7jmlo6ddo7">🧘 Movilidad Sin Dolor</p>
            <p className="mt-2 text-sm leading-relaxed text-white/60" data-id="element-76" data-mp="1hi4d0wsjqze4">
              Programa online de movilidad y estiramientos para aliviar el dolor de forma natural y
              sostenible.
            </p>
          </div>
          <nav aria-label="Enlaces del pie de página" data-id="element-77" data-mp="1rdo495w619wj">
            <ul className="flex flex-wrap gap-x-6 gap-y-2 text-sm" data-id="element-78" data-mp="13p4wcrh12z4z">
              {links.map(l => <li key={l} data-id="element-79" data-mp="yrd8q9nf1z6l">
                  <a href="#" className="transition-colors hover:text-white" data-id="element-80" data-mp="yq2467m5cnef">
                    {l}
                  </a>
                </li>)}
            </ul>
          </nav>
        </div>

        <div className="mt-6 space-y-1 text-xs text-white/45" data-id="element-81" data-mp="1ii4abfr84gty">
          <p data-id="element-82" data-mp="1na49h5zgz5ph">© 2025 Movilidad Sin Dolor · Todos los derechos reservados.</p>
          <p data-id="element-83" data-mp="1s97ewrjd3dxz">
            Este programa es de carácter informativo y no reemplaza la consulta médica profesional.
          </p>
        </div>
      </div>
    </footer>;
}